import { useState } from 'react';
import CityPickerModal from './CityPickerModal';

export default function FloatingWhatsApp() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setModalOpen(true)}
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-green-500 hover:bg-green-400 text-black font-bold pl-4 pr-5 py-3 rounded-full transition-all duration-300 hover:scale-110 cursor-pointer whitespace-nowrap"
        style={{ boxShadow: '0 0 30px rgba(34,197,94,0.6), 0 4px 20px rgba(0,0,0,0.4)' }}
        aria-label="Şehir seçerek WhatsApp ile bağlan"
      >
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-whatsapp-line text-xl" />
        </div>
        <span className="text-sm hidden sm:block">WhatsApp&apos;a Bağlan</span>
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-20 pointer-events-none" />
      </button>

      {modalOpen && (
        <CityPickerModal
          categoryName="Kampanya Kupon"
          section="floating_button"
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
